import config from 'config';

export const isVirginExperienceDaysVoucher = (
  redeemedSegment = null,
  redeemedProduct = null,
) => {
  if (!config.virginBrandId) {
    console.error('Virgin brand ID is not configured');
    return false;
  }

  if (!redeemedSegment || !redeemedProduct) {
    return false;
  }

  const voucherType = redeemedSegment?.voucherType;
  const fulfilmentBehaviour =
    redeemedSegment?.configuration?.fulfilmentBehaviour?.type;
  const brandId = redeemedProduct?.brandId;
  const behaviouralType = redeemedProduct?.behaviouralType;

  const isVirginBrand = brandId === config.virginBrandId;
  const isFormRedemption = voucherType === 'form-redemption';
  const isDeferredFulfilment = fulfilmentBehaviour === 'deferred';
  const isExperienceBehaviouralType = behaviouralType === 'experience';

  return (
    isVirginBrand &&
    isFormRedemption &&
    isDeferredFulfilment &&
    isExperienceBehaviouralType
  );
};
